// extracted by mini-css-extract-plugin
export var reg = "reg-module--reg--993c8";
export var regBox = "reg-module--reg-box--4e24a";
export var regBox__body = "reg-module--reg-box__body--56088";
export var regBox__head = "reg-module--reg-box__head--6ca78";